import React from 'react';

export const MandatoryWarning = () => (
  <div className="col-12 text-center">
    <span style={{ color: '#FF5D5D', fontWeight: '600', fontSize: '16px' }}>
      Please answer all mandatory questions.
    </span>
  </div>
);
